<template>
  <div class="filter">
    <h4>Фильтры</h4>
    <vue-custom-scrollbar class="scroll-filter">
      <div class="filter-item">
        <div class="filter-radio">
          <h5>Прошедшие кадастровый учет</h5>
          <div class="input-wrap">
            <label>
              <input name="isCheck" type="radio" hidden :value="true" v-model="isCheck">
              <span>Да</span>
            </label>
            <label>
              <input name="isCheck" type="radio" hidden :value="false" v-model="isCheck">
              <span>Нет</span>
            </label>
            <label>
              <input name="isCheck" type="radio" hidden :value="''" v-model="isCheck">
              <span>Не важно</span>
            </label>
          </div>
        </div>
      </div>
      <div class="filter-item">
        <h5>Сведения о границах внесены в кадастр недвижимости</h5>
        <div class="filter-radio">
          <div class="input-wrap">
            <label>
              <input name="isArchive" type="radio" hidden :value="true" v-model="isArchive">
              <span>Да</span>
            </label>
            <label>
              <input name="isArchive" type="radio" hidden :value="false" v-model="isArchive">
              <span>Нет</span>
            </label>
            <label>
              <input name="isArchive" type="radio" hidden :value="''" v-model="isArchive">
              <span>Не важно</span>
            </label>
          </div>
        </div>
      </div>

      <div class="filter-item">
        <h5>Аренда</h5>
        <div class="filter-radio">
          <div class="input-wrap">
            <label>
              <input name="isRented" type="radio" hidden :value="true" v-model="isRented">
              <span>Да</span>
            </label>
            <label>
              <input name="isRented" type="radio" hidden :value="false" v-model="isRented">
              <span>Нет</span>
            </label>
            <label>
              <input name="isRented" type="radio" hidden :value="null" v-model="isRented">
              <span>Не важно</span>
            </label>
          </div>
        </div>
      </div>

      <div class="filter-item">
        <h5>Кадастровая стоимость</h5>
        <FilterCostVue></FilterCostVue>
      </div>

      <div class="filter-item">
        <h5>Площадь (фактическая)</h5>
        <FilterRangeVue @setInput="setAreaGeom($event)"></FilterRangeVue>
      </div>

      <div class="filter-item">
        <h5>Площадь (по документам)</h5>
        <FilterRangeVue @setInput="setAreaDocs($event)"></FilterRangeVue>
      </div>

      <!-- Район -->
      <div class="filter-item">
        <h5>Район</h5>
        <div class="filter-list">
          <div class="address-list">
            <span v-for="item in region" :key="item.id">
              <img src="@img/close.svg" @click="deselectFilter({key: 'region', value: item}, regionTreeId)" alt="">
              {{ item.text }}
            </span>
          </div>
          <button @click="showPopup('region')">+ Добавить район</button>
        </div>
      </div>

      <!-- Вид угодий -->
      <div class="filter-item">
        <h5>Вид угодий</h5>
        <div class="filter-list">
          <div class="address-list">
            <span v-for="item in tluList" :key="item.id">
              <img src="@img/close.svg" @click="deselectFilter({key: 'tlu', value: item}, tluTreeId)" alt="">
              {{ item.text }}
            </span>
          </div>
          <button @click="showPopup('tlu')">+ Добавить вид угодий</button>
        </div>
      </div>

      <!-- Вид ЗУ -->
      <div class="filter-item">
        <h5>Вид ЗУ</h5>
        <div class="filter-list">
          <div class="address-list">
            <span v-for="item in typeZuList" :key="item.id">
              <img src="@img/close.svg" @click="deselectFilter({key: 'typeZu', value: item}, typeZuTreeId)" alt="">
              {{ item.text }}
            </span>
          </div>
          <button @click="showPopup('typeZu')">+ Добавить вид ЗУ</button>
        </div>
      </div>

      <!-- Вид права -->
      <div class="filter-item">
        <h5>Вид права</h5>
        <div class="filter-list">
          <div class="address-list">
            <span v-for="item in rightType" :key="item.id">
              <img src="@img/close.svg" @click="deselectFilter({key: 'rightType', value: item}, rightTypeTreeId)" alt="">
              {{ item.text }}
            </span>
          </div>
          <button @click="showPopup('rightType')">+ Добавить вид права</button>
        </div>
      </div>

      <!-- Тип субъекта правоотношений -->
      <div class="filter-item">
        <h5>Тип субъекта правоотношений</h5>
        <div class="filter-list">
          <div class="address-list">
            <span v-for="item in rightOwnerGovernanceSp" :key="item.id">
              <img src="@img/close.svg" @click="deselectFilter({key: 'rightOwnerGovernanceSp', value: item}, rightOwnerGovernanceSpTreeId)" alt="">
              {{ item.text }}
            </span>
          </div>
          <button @click="showPopup('rightOwnerGovernanceSp')">+ Добавить тип субъекта правоотношений</button>
        </div>
      </div>
    </vue-custom-scrollbar>
    <div class="button-filter">
      <button @click="acceptFilter()" class="btn accent-btn filter-reset">Применить</button>
      <button @click="resetFilter()" class="btn filter-reset">Сбросить</button>
    </div>
  </div>
</template>

<script>
import { eventBus } from '@/main.js'
import FilterRangeVue from './FilterType/FilterRangeVue.vue'
import FilterCostVue from './FilterType/FilterCostVue.vue'

export default {
  name: 'FilterVue',
  components: {
    FilterRangeVue,
    FilterCostVue
  },
  data () {
    return {
      isCheck: '',
      isArchive: '',
      isRented: '',
      ownerList: '',
      geomGtTime: null,
      geomLteTime: null,
      docGtTime: null,
      docLteTime: null
    }
  },
  computed: {
    tluList () {
      return this.$store.getters.SELECTED_TLU
    },
    typeZuList () {
      return this.$store.getters.SELECTED_TYPE_ZU_LIST
    },
    rightOwnerGovernanceSp () {
      return this.$store.getters.SELECTED_RIGHT_OWNER_GOVERNANCE_SP
    },
    rightType () {
      return this.$store.getters.SELECTED_RIGHT_TYPE
    },
    region () {
      return this.$store.getters.SELECTED_REGION
    },
    tluTreeId () {
      return this.$store.getters.value('tluTreeId')
    },
    typeZuTreeId () {
      return this.$store.getters.value('typeZuTreeId')
    },
    rightOwnerGovernanceSpTreeId () {
      return this.$store.getters.value('rightOwnerGovernanceSpTreeId')
    },
    rightTypeTreeId () {
      return this.$store.getters.value('rightTypeTreeId')
    },
    regionTreeId () {
      return this.$store.getters.value('regionTreeId')
    }
  },
  watch: {
    isCheck (newVal) {
      eventBus.$emit('setLandListFilter', {key: 'isCheck', value: newVal})
    },
    isArchive (newVal) {
      eventBus.$emit('setLandListFilter', {key: 'isArchive', value: newVal})
    },
    isRented (newVal) {
      eventBus.$emit('setLandListFilter', {key: 'isRented', value: newVal})
    }
  },
  methods: {
    acceptFilter () {
      eventBus.$emit('acceptFilter')
    },

    resetFilter () {
      // console.log('click reser')
      this.isCheck = ''
      this.isArchive = ''
      this.isRented = ''
      eventBus.$emit('resetRange', '')
      this.$store.dispatch('SET_VALUE', {key: 'region', value: []})
      eventBus.$emit('setLandListFilter', {key: 'region', value: []})
      this.$store.dispatch('SET_VALUE', {key: 'tlu', value: []})
      eventBus.$emit('setLandListFilter', {key: 'tlu', value: []})
      this.$store.dispatch('SET_VALUE', {key: 'typeZu', value: []})
      eventBus.$emit('setLandListFilter', {key: 'typeZu', value: []})
      this.$store.dispatch('SET_VALUE', {key: 'rightType', value: []})
      eventBus.$emit('setLandListFilter', {key: 'rightType', value: []})
      this.$store.dispatch('SET_VALUE', {key: 'rightOwnerGovernanceSp', value: []})
      eventBus.$emit('setLandListFilter', {key: 'rightOwnerGovernanceSp', value: []})
      eventBus.$emit('resetTree')
      setTimeout(() => {
        this.acceptFilter()
      }, 50)
    },
    deselectFilter (e, treeId) {
      this.$store.dispatch('delFlterId', {key: e.key, id: e.value.id})
      eventBus.$emit('deselectIdLandListFilter', {key: e.key, id: e.value.id})
      eventBus.$emit('deselectIdFromTree', {treeId: treeId, itemId: e.value.id})
    },
    showPopup (popupName) {
      eventBus.$emit('setShowPopup', {key: popupName, value: true})
    },
    setAreaGeom (e) {
      if (e.key === 'from') { // "from" value
        if (this.geomGtTime !== null) { // в любом случе сбрасываем таймер ввода
          clearTimeout(this.geomGtTime)
        }
        if (e.noDelay === true) { // если нет задержки
          eventBus.$emit('setLandListFilter', {key: 'areaBygeom_Gt', value: e.value})
        } else { // если есть задержка
          this.geomGtTime = setTimeout(() => {
            eventBus.$emit('setLandListFilter', {key: 'areaBygeom_Gt', value: e.value})
          }, 1000)
        }
      } else { // "to" value
        if (this.geomLteTime !== null) { // в любом случе сбрасываем таймер ввода
          clearTimeout(this.geomLteTime)
        }
        if (e.noDelay === true) { // если нет задержки
          eventBus.$emit('setLandListFilter', {key: 'areaBygeom_Lte', value: e.value})
        } else { // если есть задержка
          this.geomLteTime = setTimeout(() => {
            eventBus.$emit('setLandListFilter', {key: 'areaBygeom_Lte', value: e.value})
          }, 1000)
        }
      }
    },
    setAreaDocs (e) { // точно такая же длгика как и в setAreaGeom
      if (e.key === 'from') {
        if (this.docGtTime !== null) {
          clearTimeout(this.docGtTime)
        }
        if (e.noDelay === true) {
          eventBus.$emit('setLandListFilter', {key: 'areaBydoc_Gt', value: e.value})
        } else {
          this.docGtTime = setTimeout(() => {
            eventBus.$emit('setLandListFilter', {key: 'areaBydoc_Gt', value: e.value})
          }, 300)
        }
      } else {
        if (this.docLteTime !== null) {
          clearTimeout(this.docLteTime)
        }
        if (e.noDelay === true) {
          eventBus.$emit('setLandListFilter', {key: 'areaBydoc_Lte', value: e.value})
        } else {
          this.docLteTime = setTimeout(() => {
            eventBus.$emit('setLandListFilter', {key: 'areaBydoc_Lte', value: e.value})
          }, 300)
        }
      }
    }
  }
}
</script>

<style lang="scss">

.scroll-filter {
  position: absolute!important;
  width: 310px;
  padding-right: 20px;
  height: calc(100% - 100px);
}

.filter {
  position: absolute;
  padding: 20px 10px 20px 20px;
  width: 330px;
  height: 70%;
  max-height: 750px;
  // height: 70vh;
  top: 5px;
  right: 40px;
  border-radius: 8px;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  z-index: 1;
  h4 {
    margin-bottom: 45px;
  }
  &-item {
    border-bottom: 1px solid #e6e6e6;
    padding-top: 15px;
    padding-bottom: 15px;
    h5 {
      margin-bottom: 10px;
    }
  }
  &-reset {
    margin-top: 30px;
    margin-bottom: 10px;
    font-size: 14px;
    padding: 10px 25px;
    border: 1px solid #4E53E7;
    transition: .3s;
    &:hover {
      background-color: #4E53E7;
      color: #fff;
    }
  }
}

.button-filter {
  position: absolute;
  background-color: #fff;
  display: flex;
  justify-content: center;
  width: 330px;
  border-radius: 8px;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
  top: 95%;
  left: 0;
  button {
    margin-right: 10px;
    margin-left: 10px;
  }
}

.filter-radio {
  label {
    display: inline-block;
    user-select: none;
    cursor: pointer;
    margin-bottom: 8px;
    padding-left: 25px;
    margin-right: 10px;
  }
  span {
    position: relative;
    font-size: 12px;
    &:before {
      position: absolute;
      content: "";
      top: 0;
      left: -25px;
      width: 16px;
      height: 16px;
      border-radius: 100%;
      background-color: #d9d9d9;
      transition: .3s;
    }
    &:after {
      position: absolute;
      content: "";
      top: 4px;
      left: -21px;
      width: 8px;
      height: 8px;
      border-radius: 100%;
      background-color: #fff;
      transform: scale(0);
      box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);
      transition: .3s;
    }
  }
  input:checked + span:after {
    transform: scale(1);
  }
  input:checked + span:before {
    background-color: #45B564;
  }
}

.filter-list {
  .address-list {
    span {
      display: block;
      font-size: 12px;
      margin-bottom: 7px;
      &:hover {
        cursor: pointer;
      }
    }
    img {
      vertical-align: bottom;
    }
  }
  button {
    font-size: 12px;
    border-bottom: 1px dashed #8c8c8c;
    transition: .3s;
    &:hover {
      color: #4e53e7;
      border-color: #4e53e7;
    }
  }
}

.owner-list {
  .btn-add {
    margin-top: 10px;
    width: auto;
    padding-top: 10px;
    padding-bottom: 10px;
    font-size: 12px;
  }
  .owner-item {
    margin-top: 10px;
    cursor: pointer;
    display: inline-block;
    font-size: 12px;
    padding: 10px 15px;
    border-radius: 8px;
    border: 1px solid #e6e6e6;
    img {
      vertical-align: bottom;
      margin-left: 8px;
    }
  }
}

.filter-check {
  .input-wrap {
    position: relative;
  }
  label {
    display: block;
    user-select: none;
    cursor: pointer;
    max-width: 80%;
  }
  span {
    font-size: 12px;
    font-family: 'Montserrat_B';
    &:before {
      position: absolute;
      content: "";
      top: 1px;
      right: 0;
      width: 30px;
      height: 16px;
      border-radius: 16px;
      background-color: #d9d9d9;
      box-shadow: inset 0px 1px 1px rgba(0, 0, 0, 0.1);
      transition: .3s;
    }
    &:after {
      position: absolute;
      content: "";
      top: 3px;
      right: 16px;
      width: 12px;
      height: 12px;
      border-radius: 100%;
      background-color: #fff;
      box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);
      transition: .3s;
    }
  }
  input:checked + span:after {
    right: 2px;
  }
  input:checked + span:before {
    background-color: #45B564;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/FilterVue.vue